import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFFILIATE_PROGRAM_PROMO_CODES = Symbol('affiliate-program.promo-codes');

export const AFFILIATE_PROGRAM_PROMO_CODES_ROUTE_NAME = Symbol('affiliate-program.promo-codes');
export const AFFILIATE_PROGRAM_PROMO_CODES_LIST_ROUTE_NAME = Symbol('affiliate-program.promo-codes.list');

export const AFFILIATE_PROGRAM_PROMO_CODES_LIST_API_URL = 'admin/promo_codes/list';

export const AFFILIATE_PROGRAM_PROMO_CODES_LIST_QUERY_KEY = 'affiliate-program.promo-codes.list';

export const AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS = {
  SHOW: new Permission(PermissionsList.admin.PROMOCODES_SHOW),
  CREATE: new Permission(PermissionsList.admin.PROMOCODES_CREATE),
};
